import { g as d } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as s, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconTrash",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function f(e, t, l, _, v, i) {
  return n(), s("svg", {
    "aria-label": l.ariaLabel,
    class: o([i.iconSizeClass, "d-icon d-icon--trash"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Trash",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M5 5a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0v-3A.5.5 0 0 1 5 5Zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0v-3A.5.5 0 0 1 7 5Z" }, null, -1),
      a("path", { d: "M1.5 2.5a.5.5 0 0 0 0 1H2V10c0 .413.201.784.46 1.041.257.258.628.46 1.04.46h5c.413 0 .784-.202 1.041-.46.258-.258.46-.628.46-1.04V3.5h.5a.5.5 0 0 0 0-1h-2V2c0-.413-.202-.784-.46-1.042C7.784.701 7.413.5 7.001.5H5c-.413 0-.784.201-1.042.46-.258.257-.459.628-.459 1.04v.5h-2ZM3 10a.51.51 0 0 0 .166.334.51.51 0 0 0 .334.166h5a.51.51 0 0 0 .334-.166A.511.511 0 0 0 9 10V3.5H3V10Zm1.5-8a.51.51 0 0 1 .166-.334A.51.51 0 0 1 5 1.5h2a.51.51 0 0 1 .334.166A.51.51 0 0 1 7.5 2v.5h-3V2Z" }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, h);
}
const A = /* @__PURE__ */ u(c, [["render", f]]);
export {
  A as default
};
//# sourceMappingURL=trash.js.map
